module.exports = __webpack_public_path__ + "static/img/bg2@2x.6baedfb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/SPSR/bg2@2x.png
// module id = 52Sh
// module chunks = 70